import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ErrorService } from '../../services/error.service';
import { ParserService } from '../../services/parser.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { Constants, Language, EmailType } from '../../global/constants';

@Component({
  selector: 'app-admin-parser',
  templateUrl: './admin-parser.component.html'
})
export class AdminParserComponent implements OnInit {

  loadingPage = true;
  addTrainingDialogRef: BsModalRef;

  parserData: any[] = [];

  newTraining: any = {
    content: '',
    language: 'en',
    category: 'n/a',
    cutoff: false
  };

  pages: any[] = [
    {
      page: 'footerCruft',
      header: 'Footer Cruft',
      collection: 'footer_cruft',
      help: 'Footer cruft is used to remove common footer content from processing such as legal notifications'
    },
    {
      page: 'subjectCruft',
      header: 'Subject Cruft',
      collection: 'subject_cruft',
      help: 'Subject cruft is used to remove common footer content from the subject for cleaner display in the UI and data sync'
    }
  ];

  currentPage: any = this.pages[0];

  constructor(private errorService: ErrorService,
              private modalService: BsModalService,
              private parserService: ParserService,
              private constants: Constants,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.changePage(this.currentPage);
  }

  changePage(page: any) {
    this.currentPage = page;
    this.refreshData();
  }

  addTraining(dialog) {
    this.addTrainingDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  saveTraining() {
    this.addTrainingDialogRef.hide();
    this.parserService.newTraining(this.currentPage.collection, this.newTraining.content, this.newTraining.language, this.newTraining.category, this.newTraining.cutoff).subscribe(
      (result: any) => {
        this.globalMessageService.message('Training added');
        this.newTraining = {
          content: '',
          language: 'en'
        };
        this.refreshData();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-parser.component', 'addTraining.100');
      }
    )
  }

  deleteTraining(training) {
    this.parserService.deleteTraining(this.currentPage.collection, training._id).subscribe(
      (result: any) => {
        this.globalMessageService.message('Training deleted');
        this.refreshData();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-parser.component', 'deleteTraining.100');
      }
    )
  }

  private refreshData() {
    this.loadingPage = true;
    this.parserService.getTraining(this.currentPage.collection).subscribe(
      (result: any) => {
        this.parserData = result;
        this.loadingPage = false;
        this.parserData.forEach((d) => {
          d.lang = this.constants.languages.find((l) => {return l.name==d.language}).display;
        });
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-parser.component', 'refreshData.100');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-parser/admin-parser.component.ts